import { FeatureFlagsState } from "./interfaces";

export const getDefaultState = (): FeatureFlagsState => {
  return {
    featureFlags: {}
  };
};

// initial state
export const state: FeatureFlagsState = getDefaultState();
